//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    categories: {
      type: Array,
      default: () => {
        return []
      }
    },

    title: {
      type: String,
      default: ''
    },

    basePath: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      showMenu: false
    }
  },

  computed: {
    activeSubcategory() {
      let activeSubcategory = ''

      this.categories.forEach((category) => {
        category.subcategories.forEach((subcategory) => {
          if (subcategory.active) {
            activeSubcategory = subcategory
          }
        })
      })

      return activeSubcategory
    }
  },

  methods: {
    toggleSubcategory(category) {
      category.active = !category.active
    },

    toggleMenu() {
      this.showMenu = !this.showMenu
    }
  }
}
